import type { Metadata } from "next";
import "./globals.scss";
import "./styles.scss";
import "./styles2.scss";
import { Suspense } from "react";
import { StoreProvider } from "@/lib/storeprovider";
import { Toaster } from "react-hot-toast";
export const metadata: Metadata = {
  title: "Women Cart",
  description: "Ecommerce",
};

export default function RootLayout({
  children,
}: Readonly<{ children: React.ReactNode }>) {
  return (
    <html lang="en">
      <body>
        <StoreProvider>
          <Toaster />
          <Suspense>{children}</Suspense>
        </StoreProvider>
      </body>
    </html>
  );
}
